import React, { useState } from 'react'
import { useRequest } from 'ahooks';
import { getLine, updateLine } from '../../../service/theme';
import { Modal, Toast } from 'antd-mobile';
import { userStore } from '../../../store';
import { useNavigate } from 'react-router-dom';


export default function useLineService() {


    const [lines, setLines] = useState([]);

    const navigate = useNavigate();

    const { loading: loadingLine, run: runGetLine } = useRequest(getLine, {
        manual: true,
        onSuccess: (res) => {
            if (res.status) {
                // console.log(res.data.rows)
                setLines(res.data.rows)
            }else{
                Toast.show({
                    content: res.msg
                })
            }
        },
        onError: (res) => {
            Toast.show({
                content: '请求条线信息出错了'
            })
        }
    })

    const { run: runUpdateLine } = useRequest((params) => updateLine(params), {
        manual: true,
        onSuccess: (res, param) => {
            if (res.status) {
                // console.log(param)
                userStore.lineId = param[0].lineId
                Modal.clear()
                navigate('/')
            }
        }
    })

    return {
        lines,
        loadingLine,
        runGetLine,
        runUpdateLine
    }

}
